import {
  AdminPanelSettingsOutlined,
  Apps,
  AutoAwesome,
  Business,
  CellTower,
  CleaningServices,
  ConnectWithoutContact,
  CreditCard,
  HeadsetMic,
  Home,
  Hub,
  Language,
  Lock,
  Payments,
  PendingActions,
  PunchClockOutlined,
  ShareLocation,
  SpaceDashboard,
  Storefront,
  ViewQuilt,
} from "@mui/icons-material";
import { ClientsTable } from "../../clients/clientsTable";
import { ConnectBusinessCoverageArea } from "../../connectBusinessCoverageArea";
import { ConnectionRequests } from "../../connectionRequests";
import { HoursOfOperation } from "../../hoursOfOperation";
import { CalendarJobsCustom } from "../../jobs2/CalendarJobsCustom";
import { PayoutMethods } from "../../payments/PayoutMethods";
import { ServicesTab } from "../../services/ServicesTab";
import { VendorsTable } from "../../vendors/vendorsTable";
// import { WorkforceCreateView } from "../../workforce/views/WorkforceCreateView";
import { WorkforceList } from "../../employees/components/WorkforceList.tsx";

import { ViewKanbanOutlined } from "@mui/icons-material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import GroupsIcon from "@mui/icons-material/Groups";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import { appStates } from "../../../redux/features/appStateSlice";
import { IRoles } from "../../../utils";
import { ManageAdmins } from "../../admins/ManageAdmins";
import { FlowDoMainLayout } from "../../flow-do/components/FlowDoMainLayout";

import ContactCenterDashboard from "@components/superadmin/contact-center/ContactCenterDashboard";
import CompaniesView from "@components/superadmin/views/companiesView/CompaniesView";
import { UserView } from "@components/superadmin/views/usersView/UserView";
import { EBenefitTypes } from "../../../permissions/benefits/enums/benefits.enums";
import JobsList from "../../jobs/jobs-list/JobsList";
import VaultContent from "../../password-baul/component/principals/VaultContent";
import PrivacyPolicy from "../../privacy-policy";
import { TermsAndConditions } from "../../termsAndConditions";
import TimeSheet from "../../time-sheet/TimeSheet";
import { HelpSupportMessage } from "./HelpContent";

// import KanbanBoard from 'mdi-material-ui/KanbanBoard';
// import { FlowDoWidget } from "../../flowDo/FlowDoWidget";

export const getToolkitWidgets = (colors) => [
  {
    key: "Dashboard-Clients-Intelligence",
    label: "Clients",
    icon: Diversity3Icon,
    iconColor: colors.info[700],
    iconBg: colors.info[50],
    modalKey: "Dashboard-Clients-Intelligence",
    // benefit: EBenefitTypes.CLIENT_MANAGEMENT,
    content: <ClientsTable showContactsToggle />,
    headless: true,
    roles: [IRoles.Business, IRoles.Admin, IRoles.Manager, IRoles.VR, IRoles.Other],
  },
  {
    key: "Dashboard-Companies-Intelligence",
    label: "Companies",
    icon: Business,
    iconColor: colors.info[700],
    iconBg: colors.info[50],
    modalKey: "Dashboard-Companies-Intelligence",
    content: <CompaniesView />,
    headless: true,
    roles: [IRoles.SuperAdmin],
  },
  {
    key: "Dashboard-ContactCenter-SuperAdmin",
    label: "Contact Center",
    icon: HeadsetMic,
    iconColor: colors.info[700],
    iconBg: colors.info[50],
    modalKey: "Dashboard-ContactCenter-SuperAdmin",
    content: <ContactCenterDashboard />,
    headless: true,
    roles: [IRoles.SuperAdmin],
  },
  {
    key: "Dashboard-Users-Intelligence",
    label: "Users",
    icon: Business,
    iconColor: colors.info[700],
    iconBg: colors.info[50],
    modalKey: "Dashboard-Users-Intelligence",
    content: <UserView />,
    headless: true,
    roles: [IRoles.SuperAdmin],
  },
  {
    key: "Dashboard-Jobs-Business",
    label: "Jobs",
    icon: WorkHistoryIcon,
    iconColor: colors.info[700],
    iconBg: colors.info[50],
    modalKey: "Dashboard-Jobs-Business",
    // benefit: EBenefitTypes.SCHEDULING,
    content: <JobsList />,
    roles: [IRoles.Business, IRoles.Manager, IRoles.VR, IRoles.Other],
  },
  {
    key: "Dashboard-JobsCalendar-Business",
    label: "Calendar",
    icon: CalendarMonthIcon,
    iconColor: colors.info[700],
    iconBg: colors.info[50],
    modalKey: "Dashboard-JobsCalendar-Business",
    // benefit: EBenefitTypes.SCHEDULING,
    content: <CalendarJobsCustom defaultMode="month" />,
    headless: true,
    roles: [IRoles.Business, IRoles.Manager, IRoles.VR, IRoles.Other],
  },
  {
    key: "Dashboard-Workforces-List",
    label: "Workforces",
    icon: GroupsIcon,
    iconColor: colors.orange[600],
    iconBg: colors.orange[50],
    modalKey: "Dashboard-Workforces-List",
    content: <WorkforceList />,
    roles: [IRoles.Business, IRoles.Manager, IRoles.VR, IRoles.Other],
  },
  {
    key: "Dashboard-FlowDo-Business",
    label: "Flow Do",
    icon: ViewKanbanOutlined,
    iconColor: colors.info[700],
    iconBg: colors.info[50],
    modalKey: "Dashboard-FlowDo-Business",
    benefit: EBenefitTypes.FLOW_DO,
    content: <FlowDoMainLayout />,
    roles: [IRoles.Business, IRoles.Admin, IRoles.Manager, IRoles.VR, IRoles.Other, IRoles.SuperAdmin],
  },
  {
    key: "Dashboard-Connections-Business",
    label: "Connections",
    icon: ConnectWithoutContact,
    iconColor: colors.success[400],
    iconBg: colors.success[50],
    modalKey: "Dashboard-Connections-Business",
    benefit: EBenefitTypes.FINDACLEANER,
    content: <ConnectionRequests sx={{ width: "100%", height: "100%" }} />,
    defaultSizes: { width: 1200, height: 700 },
    fitContentHeight: false,
    headless: true,
    roles: [IRoles.Business, IRoles.Manager, IRoles.VR, IRoles.Other],
  },
  {
    key: "Dashboard-Vendors-Intelligence",
    label: "Vendors",
    icon: Storefront,
    iconColor: colors.orange[600],
    iconBg: colors.orange[50],
    modalKey: "Dashboard-Vendors-Intelligence",
    content: <VendorsTable />,
    headless: true,
    roles: [IRoles.Business, IRoles.Admin, IRoles.Manager, IRoles.VR, IRoles.Other],
  },
  {
    key: "Organization-CoverageAreas-Business",
    label: "Coverage Areas",
    icon: ShareLocation,
    iconColor: colors.info[700],
    iconBg: colors.info[50],
    modalKey: "Organization-CoverageAreas-Business",
    benefit: EBenefitTypes.AREASCOVERAGES,
    content: <ConnectBusinessCoverageArea />,
    roles: [IRoles.Business, IRoles.Manager, IRoles.VR, IRoles.Other],
  },
  {
    key: "Organization-ManageServices-Business",
    label: "Manage Services",
    icon: CleaningServices,
    iconColor: colors.orange[600],
    modalKey: "Organization-ManageServices-Business",
    iconBg: colors.orange[50],
    content: <ServicesTab />,
    roles: [IRoles.Business, IRoles.Manager, IRoles.VR, IRoles.Other],
  },
  {
    key: "Organization-PayoutMethods-Business",
    label: "Payout Methods",
    icon: Payments,
    iconColor: colors.success[400],
    iconBg: colors.success[50],
    modalKey: "Organization-PayoutMethods-Business",
    // benefit: EBenefitTypes.INVOICING,
    content: <PayoutMethods />,
    roles: [IRoles.Business, IRoles.Manager, IRoles.VR, IRoles.Other],
  },
  {
    key: "Organization-ManageHours-Business",
    label: "Manage Hours",
    icon: PendingActions,
    iconColor: colors.info[700],
    iconBg: colors.info[50],
    modalKey: "Organization-ManageHours-Business",
    benefit: EBenefitTypes.SCHEDULING,
    content: <HoursOfOperation />,
    roles: [IRoles.Business, IRoles.Manager, IRoles.VR, IRoles.Other],
  },
  {
    key: "Organization-PasswordVault-Business",
    headless: true,
    label: "Password Vault",
    icon: Lock,
    iconColor: colors.info[700],
    iconBg: colors.info[50],
    modalKey: "Organization-PasswordVault-Business",
    benefit: EBenefitTypes.PASSWORD_VAULT,
    content: <VaultContent />,
    roles: [IRoles.Business, IRoles.Admin, IRoles.Manager, IRoles.VR, IRoles.Other, IRoles.SuperAdmin],
  },
  {
    key: "Organization-ManageAdmins-Business",
    label: "Manage Admins",
    icon: AdminPanelSettingsOutlined,
    iconColor: colors.success[700],
    modalKey: "Organization-ManageAdmins-Business",
    iconBg: "rgba(33, 150, 243, 0.10)",
    //benefit: EBenefitTypes.SEATS, Maybe this one goes somewhere else
    content: <ManageAdmins />,
    roles: [IRoles.Business, IRoles.Admin, IRoles.Manager, IRoles.VR, IRoles.Other, IRoles.SuperAdmin],
  },
  {
    key: "Organization-TimeSheet-Business",
    headless: true,
    label: "Time Sheet",
    icon: PunchClockOutlined,
    iconColor: colors.info[700],
    iconBg: colors.info[50],
    modalKey: "Organization-TimeSheet-Business",
    content: <TimeSheet />,
    roles: [IRoles.Business, IRoles.Manager, IRoles.VR, IRoles.Other],
  },
];
export const getPages = (roleType, handlers) => [
  {
    name: {
      business: "Flow Hub",
      employee: "Flow Hub",
      admin: "Flow Hub",
      virtualReceptionist: "Flow Hub",
      accountManager: "Flow Hub",
      other: "Flow Hub",
      superadmin: "Flow Hub",
    },
    callback: handlers.handleFlowHub,
    icon: <Hub />,
    roles: [IRoles.Business, IRoles.Manager, IRoles.VR, IRoles.Employee, IRoles.Other],
  },
  {
    name: {
      business: "Dashboard",
      employee: "Dashboard",
      admin: "Dashboard",
      virtualReceptionist: "Dashboard",
      accountManager: "Dashboard",
      other: "Dashboard",
      superadmin: "Dashboard",
    },
    callback:
      roleType === "business" || roleType === "admin" || roleType === "virtualReceptionist" || roleType === "other" || roleType === "superadmin"
        ? handlers.handleBusiness
        : handlers.handleHome,
    icon: roleType === "employee" ? <Home /> : <SpaceDashboard />,
    roles: [IRoles.Business, IRoles.Admin, IRoles.Manager, IRoles.VR, IRoles.Employee, IRoles.SuperAdmin, IRoles.Other],
    isToolkit:
      roleType === "business" ||
      roleType === "admin" ||
      roleType === "virtualReceptionist" ||
      roleType === "accountManager" ||
      roleType === "other" ||
      roleType === "superadmin",
  },
  {
    name: {
      business: "Smart Agenda",
      admin: "Smart Agenda",
      virtualReceptionist: "Smart Agenda",
      accountManager: "Smart Agenda",
      other: "Smart Agenda",
      superadmin: "Smart Agenda",
    },
    callback: (i) => handlers.guardedNavigate(i, "/agenda-inteligente", appStates.AGENDAINTELIGENTE),
    icon: <AutoAwesome />,
    roles: [IRoles.Business, IRoles.Admin, IRoles.Manager, IRoles.VR, IRoles.Other, IRoles.SuperAdmin],
  },
  {
    name: {
      business: "Organization",
      admin: "Organization",
      employee: "Organization",
      virtualReceptionist: "Organization",
      accountManager: "Organization",
      other: "Organization",
      superadmin: "Organization",
    },
    callback: (i) => handlers.guardedNavigate(i, "/organization", appStates.ORGANIZATION),
    icon: roleType === "employee" ? <Home /> : <Language />,
    roles: [IRoles.Business, IRoles.Admin, IRoles.Manager, IRoles.VR, IRoles.Other, IRoles.SuperAdmin],
    isOrganization:
      roleType === "business" ||
      roleType === "admin" ||
      roleType === "virtualReceptionist" ||
      roleType === "accountManager" ||
      roleType === "other" ||
      roleType === "superadmin",
  },
  {
    name: {
      business: "My Connections",
      employee: "My Connections",
      admin: "My Connections",
      virtualReceptionist: "My Connections",
      accountManager: "My Connections",
    },
    callback: (i) => handlers.guardedNavigate(i, "/my-connections", appStates.MYCONNECTIONS),
    icon: <CellTower />,
    roles: [IRoles.Employee],
  },

  {
    name: { employee: "Work Setup" },
    callback: (i) => handlers.guardedNavigate(i, "/work-setup", appStates.SERVICES),
    icon: <CleaningServices />,
    roles: [IRoles.Employee],
  },

  {
    name: { employee: "Working Area" },
    callback: (i) => handlers.guardedNavigate(i, "/coverage-areas", appStates.COVERAGE),
    icon: <ShareLocation />,
    roles: [IRoles.Employee],
  },
  {
    name: {
      business: "Subscriptions",
      admin: "Subscriptions",
      virtualReceptionist: "Subscriptions",
      accountManager: "Subscriptions",
      other: "Subscriptions",
      superadmin: "Subscriptions",
    },
    callback: (i) => handlers.guardedNavigate(i, "/plan-center", appStates.PLANS),
    icon: <CreditCard />,
    roles: [IRoles.Business, IRoles.Manager, IRoles.VR, IRoles.Other, IRoles.SuperAdmin],
  },
  {
    name: {
      business: "Apps Center",
      employee: "Apps Center",
      admin: "Apps Center",
      virtualReceptionist: "Apps Center",
      accountManager: "Apps Center",
      other: "Apps Center",
      superadmin: "Apps Center",
    },
    callback: (i) => handlers.guardedNavigate(i, "/apps-center", appStates.APPS_CENTER),
    icon: <Apps />,
    roles: [IRoles.Business, IRoles.Manager, IRoles.VR, IRoles.Other],
  },
  {
    name: {
      business: "Page Builder",
      admin: "Page Builder",
      virtualReceptionist: "Page Builder",
      accountManager: "Page Builder",
      other: "Page Builder",
      superadmin: "Page Builder",
    },
    callback: (i) => handlers.guardedNavigate(i, "/page-builder", appStates.PAGE_BUILDER),
    icon: <ViewQuilt />,
    roles: [IRoles.Business, IRoles.Manager, IRoles.VR, IRoles.Other],
  },
];

export const getSideBarOptions = [
  {
    key: "terms-service",
    label: "Terms of Service",
    modalKey: "Terms-Service-Modal",
    withHelpIcon: false,
    content: <TermsAndConditions openInNewPage={false} setOpenTermsAndConditions={() => {}} />,
  },
  {
    key: "Privacy-policy",
    label: "Privacy Policy",
    modalKey: "Privacy-policy",
    withHelpIcon: false,
    content: <PrivacyPolicy />,
  },

  {
    key: "help",
    label: "Help",
    modalKey: "Help-Modal",
    withHelpIcon: true,
    content: <HelpSupportMessage emailDirection={"contact@flownect.com"} />,
  },
];
